import { render, staticRenderFns } from "./cart-card.vue?vue&type=template&id=f5aceaaa&scoped=true&lang=pug"
import script from "./cart-card.js?vue&type=script&lang=js&external"
export * from "./cart-card.js?vue&type=script&lang=js&external"
import style0 from "./cart-card.vue?vue&type=style&index=0&id=f5aceaaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5aceaaa",
  null
  
)

export default component.exports